<template>
    <div class="MaxWid">
        <div v-if="isLogin">
            <div class="Search">
                <el-input class="SearchWid" size="medium" placeholder="项目名称" v-model="xiangMuSearch.name"></el-input>
                <el-select class="SearchWid" size="medium" placeholder="审核状态" v-model="xiangMuSearch.state">
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="已审核" value="1"></el-option>
                    <el-option label="未审核" value="2"></el-option>
                </el-select>
                <el-button class="ColorBlue" size="medium" @click="Query('InstitutionalProjectReview')">查询</el-button>
            </div>
            <div class="TableBox">
                <InstitutionalProjectReview ref="InstitutionalProjectReview" :SearchInfo="xiangMuSearch" />
            </div>
        </div>
        <el-dialog title="" :visible.sync="LoginShow" width="40%" :show-close="false" :close-on-click-modal="false">
            <div class="CommLogin">
                <div class="LoginTit">欢迎登录</div>
                <div class="LoginItem">
                    <div class="LoginItemMsg">手机号</div>
                    <div class="LoginItemVal">
                        <input type="text" v-model="SetData.mobile" placeholder="请输入手机号">
                    </div>
                </div>
                <div class="LoginItem">
                    <div class="LoginItemMsg">验证码</div>
                    <div class="LoginItemVal">
                        <input class="CountTimeInput" type="text" v-model="SetData.captcha">
                        <div class="LoginItemCode" :class="{ BgGary: CountTime != 60 }" @click="GetCode">
                            {{ ShowTime }}</div>
                    </div>
                </div>
                <div class="LoginBtn" @click="LoginSuc">登录</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import InstitutionalProjectReview from '@/components/user/ReviewComponents/InstitutionalProjectReview';
export default {
    data() {
        return {
            LoginShow: true,
            isLogin: false,
            xiangMuSearch: {
                name: "",
                state: "",
            },
            SetData: {
                mobile: "",
                captcha: "",
            },
            CountTime: 60,
            ShowTime: "获取验证码",
        }
    },
    components: {
        InstitutionalProjectReview,
    },
    methods: {
        Query(t) {
            this.$refs[t].getData();
        },
        GetCode() {
            if (this.$Global.isPhone(this.SetData.mobile)) {
                this.$post('api/sms/xinxie_send', {
                    mobile: this.SetData.mobile,
                    event: "mobilelogin",
                }).then((res) => {
                    if (res.data.code == 1) {
                        this.$message({ message: res.data.msg, type: 'success' });
                        this.ShowTime = this.CountTime + "s";
                        this.CountTime--;
                        this.DomTime = setInterval(() => {
                            if (this.CountTime == 0) {
                                clearInterval(this.DomTime);
                                this.ShowTime = "获取验证码"
                                this.CountTime = 60;
                            } else {
                                this.ShowTime = this.CountTime + "s";
                                this.CountTime--;
                            }
                        }, 1000)
                    }
                })
            } else {
                this.$message({ message: '请输入正确的手机号', type: 'error' });
            }
        },
        LoginSuc() {
            var Url = 'api/user/mobilelogin';
            this.$post(Url, this.SetData).then((res) => {
                if (res.data.code == 1) {
                    localStorage.setItem("User", JSON.stringify(res.data.data));
                    this.LoginShow = false;
                    this.$message({ message: res.data.msg, type: 'success' });
                    setTimeout(() => {
                        this.isLogin = true;
                    }, 100)
                } else {
                    this.$message({ message: res.data.msg, type: 'error' });
                }
            })
        },
    }
}
</script>
<style scoped>
.MaxWid {
    max-width: 1080px;
    padding: 0 10px;
    margin: 0 auto;
}

.Search {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.SearchWid {
    width: 200px;
    margin-right: 10px;
}

.ColorBlue {
    background-color: #027cfb;
    color: #fff;
}

.TableBox {
    margin-top: 20px;
}

.LoginItem {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.LoginItemMsg {
    width: 50px;
    color: #666666;
    font-size: 16px;
    text-align: right;
}

.LoginItemMsg {
    padding: 15px 0;
}

.LoginItemVal {
    width: calc(100% - 50px);
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    flex: 1;
    margin-left: 20px;
}

.CountTimeInput {
    width: 100px;
}

.LoginItemVal input {
    padding: 15px;
    flex: 1;
}

.LoginItemVal .LoginItemCode {
    width: 100px;
    padding: 13px 0;
    color: #fff;
    background: #0385EB;
    text-align: center;
    cursor: pointer;
}

.LoginItemVal .LoginItemCode.BgGary {
    color: #fff;
    background: #bcbcbc;
    cursor: no-drop;
}

.LoginBtn {
    margin-top: 40px;
    padding: 15px 0;
    color: #fff;
    background: #0385EB;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
}

.LoginTit {
    margin-bottom: 20px;
    font-weight: 400;
    font-size: 30px;
    color: #555;
    text-align: center;
}

.CommLogin {
    width: 360px;
    margin: 0 auto;
}
</style>